import { noop } from 'lodash'
import { ModalDispatcher } from './components/ImperativeModalProvider'

class ModalManager {
  // @ts-ignore
  public dispatch: ModalDispatcher = noop

  public subscribe = (listener: ModalDispatcher) => {
    this.dispatch = listener

    return () => {
      // @ts-ignore
      this.dispatch = noop
    }
  }
}

export const modalManager = new ModalManager()

// Global function for easy access
// @ts-ignore
export const modal: ModalDispatcher = param => modalManager.dispatch(param)
